import Meta from './Meta'

export default Meta



// WEBPACK FOOTER //
// ./src/components/Meta/index.js